import React from 'react';

import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import CircularProgress from '@material-ui/core/CircularProgress';

import { OPPORTUNITY_COCKPIT_MEDIA } from '../../utils';
import {
    actionButton,
    buttonLabel,
    cornerIcon,
    descriptionTypography,
    descriptionWrap,
    eyebrowTypography,
    headerBlock,
    inner,
    root,
    titleTypography,
} from './FigmaCardBox.style';

import { toast } from 'react-toastify';

const FigmaCardBox = ({ eyebrow, title, description, buttonLabel: label, isButton, isRouterLink, routerLink, appid, isViewEnable, chartUniqueId, formData }) => {
    const isLoading = isViewEnable === true && !!formData?.[`${chartUniqueId}_last_updated_document_id_loading`];

    const handleOpenView = (viewPage) => {
        if (isLoading) return;
        const lastUpdatedDocId = formData?.document?.[`${chartUniqueId}_last_updated_document_id`]?._id;
        const noDocumentFound = formData?.document?.[`${chartUniqueId}_last_updated_document_id`]?.message;
        if (isViewEnable === true) {
            if (noDocumentFound !== undefined && noDocumentFound !== null) {
                toast.error(noDocumentFound);
                return;
            }
            else {
                if (lastUpdatedDocId) {
                    const path = `/${appid}/page/${viewPage}/${lastUpdatedDocId}`;
                    window.open(path, '_blank', 'noopener,noreferrer');
                }
                else {
                    return;
                }
            }
        }
        else {
            const path = `/${appid}/page/${viewPage}`;
            window.open(path, '_blank', 'noopener,noreferrer');
        }

    }
    return (
        <div style={root}>
            <div style={inner}>
                <div style={headerBlock}>
                    <Typography component="div" style={eyebrowTypography} title={eyebrow}>
                        {eyebrow}
                    </Typography>
                    <Typography component="div" style={titleTypography} title={title}>
                        {title}
                    </Typography>
                </div>

                <div style={descriptionWrap}>
                    <Tooltip title={description} placement="top" enterDelay={300}>
                        <Typography component="div" style={descriptionTypography}>
                            {description}
                        </Typography>
                    </Tooltip>
                </div>

                <Button variant="outlined" style={actionButton} title={label} disabled={!isButton || isLoading} onClick={() => isRouterLink && handleOpenView(routerLink)}>
                    {isLoading
                        ? <CircularProgress size={18} style={{ color: '#3F51B5' }} />
                        : <span style={buttonLabel}>{label}</span>
                    }
                </Button>
            </div>
            <img src={OPPORTUNITY_COCKPIT_MEDIA.cardIcon} alt="" style={cornerIcon} />
        </div>
    );
};

export default FigmaCardBox;
